export default __webpack_public_path__ + "static/media/bioarray-logo.bc0d8068.png";